export default "__VITE_ASSET__B5EuH3df__"